import { render, staticRenderFns } from "./ModalNewVersionDeployed.vue?vue&type=template&id=1f72e63a&"
import script from "./ModalNewVersionDeployed.vue?vue&type=script&lang=js&"
export * from "./ModalNewVersionDeployed.vue?vue&type=script&lang=js&"
import style0 from "./ModalNewVersionDeployed.vue?vue&type=style&index=0&id=1f72e63a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports